export enum EnumTpPagamento {
    CC = 'CC',
    TED = 'TED'
}